// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__wcqeM","header":"MergedInvoice_header__1gZDX"};